import React from "react";
import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" seoKey="terms-and-conditions">
      <p>By accessing or using the Gulfudaan website and services, you agree to be bound by these Terms &amp; Conditions.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Services</h3>
      <p>Gulfudaan provides facilitation services for GAMCA medical appointments, visa appointments, dummy tickets, hotel bookings, and related immigration support services. We act as a facilitator and are not affiliated with any government body.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Accuracy of Information</h3>
      <p>Customers are responsible for providing accurate information and documents. Gulfudaan is not liable for delays or rejections caused by incorrect or incomplete information provided by the customer.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Payments</h3>
      <p>All payments are processed securely through Razorpay. Service fees are non-transferable unless stated otherwise in our Cancellation &amp; Refund Policy.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Limitation of Liability</h3>
      <p>Gulfudaan shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Contact</h3>
      <p>For questions regarding these terms, contact help@gulfudaan.com or +91 73143 44673.</p>
    </LegalLayout>
  );
}
